import {clone, forEach, get, isEmpty, set, unset} from 'lodash';
import React, {CSSProperties, FunctionComponent, useState} from 'react';
import {useDispatch} from 'react-redux';
import {NotificationEditorContentProps} from '../..';
import {InputLabelEditor} from '../../../InputLabelEditor';
import TargetingQueries from '../../../TargetingQueries';

const Styles: Record<string, CSSProperties> = {
  linkContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  button: {
    height: 48,
    width: 150,
    color: '#4054CC',
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#4054CC',
    fontWeight: 'bold',
    marginTop: 8,
  },
};

export const NotificationEditorTargeting: FunctionComponent<
  NotificationEditorContentProps
> = ({data, onChange, calculateBlogPostTargeting}) => {
  const [targetNumber, setTargetNumber] = useState<number | undefined>();
  const [recentlyConnectedCount, setRecentlyConnectedCount] = useState<
    number | undefined
  >();
  const dispatch = useDispatch();

  const onChangeTargetingData = (value, key) => {
    if (data.targeting?.fields) {
      onChange('targeting.fields', set(data.targeting?.fields, key, value));
    }
  };

  const deleteTargetingQuery = key => {
    const freshData = clone(data.targeting?.fields);
    unset(freshData, key);
    const parentKey = key.split('.');
    parentKey.splice(key.split('.').length - 1, 1);
    const parent = get(freshData, parentKey.join('.')) || freshData;
    const normalize = object => {
      let i = 1;
      const newParent = {};
      forEach(object, o => {
        newParent[i] = o;
        if (i === 1) delete newParent[i].operator;
        i++;
      });
      set(freshData || {}, parentKey, newParent);
    };
    normalize(parent);
    onChange('targeting.fields', freshData);
  };

  const addTargetingQuery = (key: number) => {
    const freshData = clone(data.targeting?.fields);
    let parent = get(freshData, key);
    if (parent.type === 'group') {
      if (!Object.keys(parent.fields).length) {
        parent = {
          type: 'field',
          name: 'id',
          fieldType: 'string',
          operation: 'equal',
          parameter: '',
        };
        set(freshData, key, parent);
      } else {
        const needOperator =
          Object.keys(parent.fields).length >= 1 || undefined;
        parent.fields[
          Object.keys(parent.fields).length
            ? parseInt(
                Object.keys(parent.fields)[
                  Object.keys(parent.fields).length - 1
                ],
                10,
              ) + 1
            : 1
        ] = {
          operator: needOperator && 'AND',
          type: 'field',
          name: 'id',
          fieldType: 'string',
          operation: 'equal',
          parameter: '',
        };
      }
    } else {
      parent = {
        type: 'group',
        operator: parent?.operator,
        fields: {
          1: {
            ...parent,
            type: 'field',
            operator: undefined,
          },
          2: {
            operator: 'AND',
            type: 'field',
            name: 'id',
            fieldType: 'string',
            operation: 'equal',
            parameter: '',
          },
        },
      };
      set(freshData, key, parent);
    }
    onChange('targeting.fields', freshData);
  };

  const onChangeOperator = key => {
    const freshData = clone(data.targeting?.fields);
    const parent = get(freshData, key);
    parent.operator = parent.operator === 'AND' ? 'OR' : 'AND';
    onChange('targeting.fields', freshData);
  };

  return (
    <div>
      <div style={Styles.linkContainer}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.google.com/spreadsheets/d/1567fjuysyUYywDF5PIBG6Xin1vBryTDVbfkYnFL82BM/edit#gid=502795437">
          Liste des variables
        </a>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        {data.targeting?.fields && !isEmpty(data.targeting?.fields) ? (
          <TargetingQueries
            onChange={onChangeTargetingData}
            data={data.targeting?.fields}
            onDelete={deleteTargetingQuery}
            onAdd={addTargetingQuery}
            onChangeOperator={onChangeOperator}
          />
        ) : (
          <button
            className="btn btn-success"
            onClick={() =>
              onChange('targeting.fields', {
                1: {
                  type: 'field',
                  name: 'id',
                  fieldType: 'string',
                  operation: 'equal',
                  parameter: '',
                },
              })
            }>
            Add targeting
          </button>
        )}
      </div>
      <>
        <div>
          <InputLabelEditor title="RESULTAT CIBLAGE" />
          <div>
            <span>La notification sera envoyée à </span>
            <span style={{fontWeight: 'bold'}}>
              {`${
                targetNumber !== undefined ? targetNumber.toLocaleString() : '-'
              } users.`}
            </span>
          </div>
          <div>
            <span>Nombre de personnes connectées récemment : </span>
            <span style={{fontWeight: 'bold'}}>
              {`${
                recentlyConnectedCount
                  ? recentlyConnectedCount.toLocaleString()
                  : '-'
              } users.`}
            </span>
          </div>
        </div>
        <button
          style={Styles.button}
          onClick={() =>
            dispatch(
              calculateBlogPostTargeting(
                data.targeting || {fields: {}},
                response => {
                  setTargetNumber(response.totalCount);
                  setRecentlyConnectedCount(response.recentlyConnectedCount);
                },
              ),
            )
          }>
          Calculate targeting
        </button>
      </>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotificationEditor/components/NotificationEditorTargeting/index.tsx